import React from 'react';
import { connect } from 'react-redux'

import { Row, Col, Divider, List, Spin, Dropdown, Button, Empty } from 'antd';
import { CloseCircleOutlined, DownCircleOutlined, EditOutlined } from '@ant-design/icons';
import InfiniteScroll from 'react-infinite-scroll-component';

class Mobile extends React.Component {
  componentDidMount() {
    this.props.fetchTable(true)
  }

  render() {
    const { table } = this.props.state
    const action = this.props.access.action

    return (
      <>
        <Row gutter={[16, 16]}>
          <Col xs={24}>
            <InfiniteScroll
              dataLength={table.data.length}
              next={this.props.fetchTable}
              hasMore={table.pagination.total != null && table.data.length < table.pagination.total}
              loader={<div style={{ textAlign: "center" }}><Spin size="small" /></div>}
              endMessage={
                table.loading_first ? "" : (table.data.length ? <Divider /> : <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Data tidak ditemukan" />)
              }
            >
              <List
                loading={table.loading_first}
                locale={{ emptyText: " " }}
                dataSource={table.data}
                renderItem={(row, i) => (
                  <List.Item
                    key={i}
                  >
                    <List.Item.Meta
                      description={<small>
                        Tingkatan Kelas: {row.tingkatan_kelas || "-"}<br />
                        Aspek Kategori: {row.ubudiyah_kategori_nama || "-"}<br />
                        Aspek Penilaian: {row.ubudiyah_aspek_nama || "-"}
                      </small>
                      }
                    />
                    <div>
                      {(!action.detail && !action.delete ? "-" : <Dropdown trigger={['click']} menu={{
                        items: [...(action.update ? [{
                          key: 0,
                          icon: <EditOutlined />,
                          label: "Update",
                          onClick: this.props.modalForm.bind(this, true, row)
                        }] : []), ...(action.delete ? [{
                          key: 1,
                          icon: <CloseCircleOutlined />,
                          label: "Delete",
                          onClick: this.props.modalDelete.bind(this, true, row)
                        }] : [])]
                      }}>
                        <Button type="primary">Opsi <DownCircleOutlined style={{ fontSize: 11 }} /></Button>
                      </Dropdown>)}
                    </div>
                  </List.Item>
                )}
              />
            </InfiniteScroll>
          </Col>
        </Row>
      </>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    privilege: state.privilege,
  }
}

export default connect(mapStateToProps)(Mobile);
